import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wfdss-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent implements OnInit {

  columns = [
    {title: 'Name', name: 'name'},
    {title: 'Created On', name: 'createdOn'},
    {title: 'Last Ran', name: 'lastRan'}
  ];
  config = {
    paging: true,
    page: {
      page: 1,
      itemsPerPage: 5
    },
    filtering: {filterString: ''},
    className: 'usa-table',
    resultsFound: true,
    sorting: {columns: this.columns}
  };

  data = [
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'},
    {name: 'Column Text', createdOn: 'Column Text', lastRan: 'Column Text'}
  ];



  constructor() { }

  ngOnInit() {
  }

}
